import { forEach } from "lodash";
import { element } from "prop-types";
import React, { useRef, useState } from "react";
import { useEffect } from "react";

import PopupEthicalPledge from "./PopupEthicalPledge";
import { Get } from "../../../lib/Config";
import { Create } from "../../../lib/Board";
import { upload } from "../../../lib/MyHttp";
import moment from "moment";
import notImage from "../../../assets/not.png";

const randomNumberString = (length = 3) => {
    const c = "0123456789";
    let s = "";
    let randomNumber = 0;

    for (let i = 0; i < length; i++) {
        randomNumber = Math.floor(Math.random() * c.length);
        s += c.substring(randomNumber, randomNumber + 1);
    }
    return s;
};

const ManagementTab2 = props => {
    const contentView = useRef(null);
    const fileForm = useRef();
    const [popClass, setPopClass] = useState(false);
    const [showRequestContent, setShowRequestContent] = useState(false);
    const [privacy, setPrivacy] = useState("");
    const [agree, setAgree] = useState(false);
    const [data, setData] = useState({
        board: "ethical",
        type: "NORMAL",
        public: "Y",
        name: "",
        email: "",
        phone: "",
        tel: "",
        title: "",
        contents: "",
        uploadFiles: "",
        password: "",
        password2: "",
        requestID: moment().format("YYMMDDHHmmss") + "" + randomNumberString()
    });

    const popClassToggle = () => {
        if (popClass) {
            setPopClass(false);
        } else {
            setPopClass(true);
        }
    };

    useEffect(() => {
        Get("PRIVACY", res => {
            setPrivacy(res.value);
        });
    }, []);

    useEffect(() => {
        if (showRequestContent) {
            contentView.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [showRequestContent]);

    /**
     * 기본 데이터 변경시
     * @param  e
     */
    const onChangeFile = async e => {
        const file = e.target.files[0];
        if (file === undefined) return;

        upload(file, file => {
            data.uploadFiles = file.id;
            setData({ ...data });
        });
    };

    const clickSave = () => {
        if (data.name === "") {
            alert("이름을 입력해주세요.");
            return;
        }
        if (data.phone === "") {
            alert("핸드폰을 입력해주세요.");
            return;
        }
        if (data.contents === "") {
            alert("내용을 입력해주세요.");
            return;
        }

        // let regPass = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,25}$/;
        // if (!regPass.test(data.password)) {
        //     alert("영문, 숫자, 특수기호 조합으로 8-20자리 이상 입력해주세요.");
        //     return;
        // }

        // if (data.password !== data.password2) {
        //     alert("비밀번호를 확인해주세요.");
        //     return;
        // }

        Create(data, res => {
            alert("등록이 완료 되었습니다.");
            // setData({
            //     board: "ethical",
            //     type: "NORMAL",
            //     public: "Y",
            //     name: "",
            //     email: "",
            //     phone: "",
            //     tel: "",
            //     title: "",
            //     contents: "",
            //     uploadFiles: "",
            //     password: "",
            //     password2: "",
            //     requestID: moment().format("YYYYMMDDHHmmss") + "" + randomNumberString()
            // });
            // fileForm.current.value = "";
            // showRequestContent(false);

            window.location = "/management/management";
        });
    };

    return (
        <>
            <section id="tab2" className="tab-cont">
                <p className="tip-tit">ktMOS 북부는 건전한 기업문화 조성 및 윤리경영의 실천을 위하여 채널을 운영하고 있습니다. ktMOS 북부 임직원의 비리행위를 제보하여 주시면 적극 조치할 것이며, 제보자의 신원은 철저히 보호됩니다.</p>

                {/* <p className="red-sub-tit">제보유형</p>
                <div className="tip-off-category">
                    <div className="example">
                        <div className="title">
                            <p>
                                ※ ktMOS 북부 임직원의 <br />
                                비리행위 이외에 서비스 이용 중 불편사항은 <br /> <b>“고객센터(1577-1535)”</b>로 접수하시면 <br /> 관련 부서에서 신속히 처리됩니다.
                            </p>
                        </div>
                        <ul className="list">
                            <li>임직원간 및 이해관계자 금품/향응 수수 및 공여</li>
                            <li>회사 공금 횡령/유용 및 회사재산 파손</li>
                            <li>기타 윤리강령에 위배되는 행위</li>
                            <li>이해관계자에게 특혜 제공 또는 지분투자 행위</li>
                            <li>고객 및 회사 정보 유츌</li>
                            <li>이해관계자와 사적인 금전거래 및 부당한 압력 행사</li>
                            <li>중복취업, 겸직 등 근무기강 관련 사항</li>
                        </ul>
                    </div>
                    <div className="btns">
                    </div>
                </div> */}
                <button type="button" onClick={popClassToggle} className="btn_nor red-line wide lg">
                    ktMOS 북부 <b>윤리강령 보기</b>
                </button>

                <p className="red-sub-tit">제보방법</p>
                <table className="tbl_normal white wAuto">
                    <colgroup>
                        <col width="20%" />
                        <col width="auto" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>웹(WEB)</th>
                            <td className="textL">ktMOS 북부 홈페이지 > 윤리경영 > 윤리위반신고</td>
                        </tr>
                        <tr>
                            <th>E-mail</th>
                            <td className="textL">ethics@ktmos.com</td>
                        </tr>
                        <tr>
                            <th>서신</th>
                            <td className="textL">서울시 강남구 광평로 47길 28. KT수서빌딩 1층 ktMOS북부 감사실</td>
                        </tr>
                    </tbody>
                </table>

                <p className="red-sub-tit" style={{ textAlign: "center" }}>
                    윤리 위반 유형
                </p>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <div style={{ display: "flex", flexDirection: "row", width: 800 }} className="violation">
                        <div style={{ flex: 1 }}>
                            <li>임직원 및 이해관계자와 금품/향응 수수 및 공여</li>
                            <li>이해관계자와 사적인 금전거래 및 부당한 압력 행사</li>
                            <li>고객 및 회사 정보 유출</li>
                        </div>

                        <div style={{ flex: 1 }}>
                            <li>이해관계자에게 특혜제공 또는 지분투자 행위</li>
                            <li>회사 공금 횡령/유용 및 회사재산 파손</li>
                            <li>중복취업, 겸직 등 근무기강 관련사항</li>
                        </div>
                    </div>
                </div>

                <div className="table-bottom-btns">
                    <button type="button" className="btn_nor red wide lg" onClick={e => setShowRequestContent(true)}>
                        윤리위반신고
                    </button>
                    {/* <button type="button" className="btn_nor red-line wide lg" onClick={e => props.onChangeTab(3)}>
                        처리결과 확인
                    </button> */}
                </div>

                <p className="red-sub-tit">제보운영</p>
                <p className="text01">
                    윤리 위반 신고는 실명으로 접수하신 경우에 조사하는 것을 원칙으로 하고 있으며, 익명의 내용이라도 내용이 구체적이고 사실근거가 명확한 경우에는 조사를 실시합니다. 사실에 근거하지 않은 비방, 개인 사생활과 관련된 사항은 처리되지 않으며, ktMOS 북부 임직원의 비리행위 이외의 경우에는
                    답변을 생략하오니 이점 양지하여 주시기 바랍니다. 제보자의 신분과 제시한 증거, 제보내용은 엄격히 보호되고 있습니다.
                </p>

                <div ref={contentView}>
                    {showRequestContent && (
                        <>
                            <div className="ethical-seperate-line" onClick={e => setShowRequestContent(false)}>
                                <a href="javascript:;">
                                    <span></span>
                                </a>
                            </div>
                            <div className="board-upload-table">
                                <table className="tbl_upload">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="35%" />
                                        <col width="15%" />
                                        <col width="35%" />
                                    </colgroup>
                                    <tbody>
                                        {/* <tr>
                                            <th>
                                                <label>게시글 유형</label>
                                            </th>
                                            <td colSpan={3}>
                                                <span>
                                                    <input
                                                        type="radio"
                                                        name="write"
                                                        id="normal_write"
                                                        checked={data.public === "Y"}
                                                        onClick={() => {
                                                            data.public = "Y";
                                                            setData({ ...data });
                                                        }}
                                                    />
                                                    <label htmlFor="normal_write">실명으로 제보하기</label>
                                                </span>
                                                <span>
                                                    <input
                                                        type="radio"
                                                        name="write"
                                                        id="secret_write"
                                                        checked={data.public === "N"}
                                                        onClick={() => {
                                                            data.public = "N";
                                                            setData({ ...data });
                                                        }}
                                                    />
                                                    <label htmlFor="secret_write">익명으로 제보하기</label>
                                                </span>
                                            </td>
                                        </tr> */}
                                        <tr>
                                            <th>
                                                <label htmlFor="upload-name">이름</label>
                                            </th>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="text_nor w100"
                                                    id="upload-name"
                                                    value={data.name}
                                                    onChange={e => {
                                                        data.name = e.target.value;
                                                        setData({ ...data });
                                                    }}
                                                />
                                            </td>
                                            <th>
                                                <label htmlFor="upload-email">이메일</label>
                                            </th>
                                            <td>
                                                <input
                                                    type="email"
                                                    className="text_nor w100"
                                                    id="upload-email"
                                                    value={data.email}
                                                    onChange={e => {
                                                        data.email = e.target.value;
                                                        setData({ ...data });
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                <label htmlFor="upload-cell">핸드폰</label>
                                            </th>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="text_nor w100"
                                                    id="upload-cell"
                                                    value={data.phone}
                                                    onChange={e => {
                                                        data.phone = e.target.value;
                                                        setData({ ...data });
                                                    }}
                                                />
                                            </td>
                                            <th>
                                                <label htmlFor="upload-phone">일반전화</label>
                                            </th>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="text_nor w100"
                                                    id="upload-phone"
                                                    value={data.tel}
                                                    onChange={e => {
                                                        data.tel = e.target.value;
                                                        setData({ ...data });
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                <label>내용입력</label>
                                            </th>
                                            <td colSpan={3}>
                                                <div className="f-row">
                                                    <input
                                                        type="text"
                                                        className="text_nor f-grow"
                                                        value={data.title}
                                                        onChange={e => {
                                                            data.title = e.target.value;
                                                            setData({ ...data });
                                                        }}
                                                    />
                                                    {/* <span className="f-shrink">
                                                    <label>
                                                        <input type="checkbox" /> 이 글을 상단에 고정합니다.
                                                    </label>
                                                </span> */}
                                                </div>
                                                <div className="edit_box">
                                                    <textarea
                                                        className="textarea_nor"
                                                        placeholder="내용입력"
                                                        style={{ height: "180px" }}
                                                        onChange={e => {
                                                            data.contents = e.target.value;
                                                            setData({ ...data });
                                                        }}
                                                    >
                                                        {data.contents}
                                                    </textarea>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                <label htmlFor="upload-edit">첨부파일</label>
                                            </th>
                                            <td colSpan={3}>
                                                <div className="f-row">
                                                    <input type="file" className="text_nor f-grow" id="upload-edit" onChange={onChangeFile} ref={fileForm} />
                                                    {data.uploadFiles !== "" && (
                                                        <button
                                                            type="button"
                                                            className="btn_nor md f-shrink black"
                                                            onClick={() => {
                                                                data.uploadFiles = "";
                                                                setData({ ...data });
                                                                fileForm.current.value = "";
                                                            }}
                                                        >
                                                            삭제
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        {/* <tr>
                                            <th>
                                                <label htmlFor="upload-edit">접수번호</label>
                                            </th>
                                            <td colSpan={3}>
                                                <div className="f-row">{data.requestID}</div>
                                            </td>
                                        </tr> */}
                                    </tbody>
                                </table>

                                {/* <div className="password-alt">
                                    <p>
                                        처리결과 확인을 위해서는 &#60;접수번호&#62;와 &#60;비밀번호&#62;가 반드시 필요합니다.
                                        <br />
                                        관련 정보를 먼저 메모하신 후 계속해서 이용해 주시기 바랍니다.
                                    </p>
                                </div> */}

                                {/* <table className="tbl_upload">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="35%" />
                                        <col width="15%" />
                                        <col width="35%" />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>
                                                <label htmlFor="upload-pwd">비밀번호</label>
                                            </th>
                                            <td colSpan={3}>
                                                <input
                                                    type="password"
                                                    className="text_nor"
                                                    id="upload-pwd"
                                                    placeholder="비밀번호 (8자리이상 영문/숫자/특수문자 혼합)"
                                                    value={data.password}
                                                    onChange={e => {
                                                        data.password = e.target.value;
                                                        setData({ ...data });
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>
                                                <label htmlFor="upload-pwd2">비밀번호 확인</label>
                                            </th>
                                            <td colSpan={3}>
                                                <input
                                                    type="password"
                                                    className="text_nor"
                                                    id="upload-pwd2"
                                                    placeholder="비밀번호확인"
                                                    value={data.password2}
                                                    onChange={e => {
                                                        data.password2 = e.target.value;
                                                        setData({ ...data });
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> */}
                            </div>

                            <p className="red-sub-tit mgt">
                                개인정보 수집 동의
                                <span className="checks">
                                    <input type="checkbox" id="agree" checked={agree} onClick={e => setAgree(!agree)} />
                                    <label htmlFor="agree">아래 사항에 동의합니다.</label>
                                </span>
                            </p>
                            <div className="privacy-agree-wrap">
                                <p className="tit">개인정보 수집 및 이용목적</p>
                                <div className="text-wrap" dangerouslySetInnerHTML={{ __html: privacy }}>
                                    {/* 윤리 위반 신고는 실명으로 접수하신 경우에 조사하는 것을 원칙으로 하고 있으며, 익명의 내용이라도 내용이 구체적이고 사실근거가 명확한 경우에는 조사를 실시합니다. 사실에 근거하지 않은 비방, 개인 사생활과 관련된 사항은 처리되지 않으며, ktMOS 북부 임직원의 비리행위
                                <br />
                                이외의 경우에는 답변을 생략하오니 이점 양지하여 주시기 바랍니다. 제보자의 신분과 제시한 증거, 제보내용은 엄격히 보호되고 있습니다.
                                <br />
                                윤리 위반 신고는 실명으로 접수하신 경우에 조사하는 것을 원칙으로 하고 있으며, 익명의 내용이라도 내용이 구체적이고 사실근거가 명확한 경우에는 조사를 실시합니다. 사실에 근거하지 않은 비방, 개인 사생활과 관련된 사항은 처리되지 않으며, ktMOS 북부 임직원의 비리행위
                                <br />
                                이외의 경우에는 답변을 생략하오니 이점 양지하여 주시기 바랍니다. 제보자의 신분과 제시한 증거, 제보내용은 엄격히 보호되고 있습니다.
                                <br />
                                윤리 위반 신고는 실명으로 접수하신 경우에 조사하는 것을 원칙으로 하고 있으며, 익명의 내용이라도 내용이 구체적이고 사실근거가 명확한 경우에는 조사를 실시합니다. 사실에 근거하지 않은 비방, 개인 사생활과 관련된 사항은 처리되지 않으며, ktMOS 북부 임직원의 비리행위
                                <br />
                                이외의 경우에는 답변을 생략하오니 이점 양지하여 주시기 바랍니다. 제보자의 신분과 제시한 증거, 제보내용은 엄격히 보호되고 있습니다.
                                <br />
                                윤리 위반 신고는 실명으로 접수하신 경우에 조사하는 것을 원칙으로 하고 있으며, 익명의 내용이라도 내용이 구체적이고 사실근거가 명확한 경우에는 조사를 실시합니다. 사실에 근거하지 않은 비방, 개인 사생활과 관련된 사항은 처리되지 않으며, ktMOS 북부 임직원의 비리행위
                                <br />
                                이외의 경우에는 답변을 생략하오니 이점 양지하여 주시기 바랍니다. 제보자의 신분과 제시한 증거, 제보내용은 엄격히 보호되고 있습니다.
                                <br /> */}
                                </div>
                                <div className="btns">
                                    <button type="button" className="btn_nor red-line wide lg" disabled={!agree} onClick={clickSave}>
                                        접수하기
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </section>
            <PopupEthicalPledge show={popClass} onClose={() => setPopClass(false)} />
        </>
    );
};

export default ManagementTab2;
